import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ResponsiveX } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import UploadDocsM from "./M/UploadDocsM";
import UploadDocsW from "./W/UploadDocsW";
import { SysConfig } from "__SYSDefault/Config";

/**
 * @augments {Component<Props, State>}
 */
class UploadDocs extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {};
  }

  componentDidMount(){
    this._setAllStates();
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(UploadDocs.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  render(){
    return ResponsiveX.Split({
      0: () => <UploadDocsM {...this.props} />,
      [SysConfig.WebUIWidth]: () => <UploadDocsW {...this.props} />
    });
  }

}

export default observer(UploadDocs);
